import { RoleValidator } from "../../../../Components/Common";
import { ROLES } from "../../../../Constants/Strings";
import { PE_SUBMIT_BUTTONS, PM_SUBMIT_BUTTONS } from "../constants";

export const PESubmitButtons = ({ handleSubmit }) => (
  <div className="flex gap-2 justify-end items-end">
    {PE_SUBMIT_BUTTONS.map((btn) => (
      <RoleValidator allowedRoles={ROLES.PROJECT_ENGINEER}>
        <button
          key={btn.status}
          onClick={() => handleSubmit(btn.status)}
          className={`px-4 py-2 ${btn.color} rounded-md transition-all`}
        >
          {btn.label}
        </button>
      </RoleValidator>
    ))}
  </div>
);

export const PMApprovalButtons = ({ handleSubmit }) => (
  <div className="flex gap-2 justify-end items-end">
    {PM_SUBMIT_BUTTONS.map((btn) => (
      <RoleValidator allowedRoles={ROLES.PROJECT_MANAGER}>
        <button
          key={btn.status}
          onClick={() => handleSubmit(btn.status)}
          className={`px-4 py-2 ${btn.color} rounded-md transition-all`}
        >
          {btn.label}
        </button>
      </RoleValidator>
    ))}
  </div>
);